import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-cm-helper',
  template: `
    <p>
      ngx-cm-helper-lib works!
    </p>
  `,
  styles: []
})
export class NgxCmHelperLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
